import src from "IMAGE";
export default { src, width: 690, height: 451, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
